import { types } from "mobx-state-tree";
export const model = types
    .model({
    storedQueryParams: types.map(types.map(types.maybe(types.string))),
})
    .actions((self) => ({
    storeQueryParams: (storageKey, params) => {
        self.storedQueryParams.set(storageKey, params);
    },
    onLoad: () => { },
}))
    .views((self) => ({
    getQueryParams: (storageKey) => {
        return (self.storedQueryParams.get(storageKey)?.toJSON() ??
            {});
    },
}));
export const queryParamsStore = model.create({
    storedQueryParams: {},
});
export default queryParamsStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlcnlQYXJhbXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc3RvcmUvcXVlcnlQYXJhbXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRXhDLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRyxLQUFLO0tBQ3ZCLEtBQUssQ0FBQztJQUNMLGlCQUFpQixFQUFFLEtBQUssQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO0NBQ25FLENBQUM7S0FDRCxPQUFPLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDbEIsZ0JBQWdCLEVBQUUsQ0FBQyxVQUFrQixFQUFFLE1BQXdCLEVBQVEsRUFBRTtRQUN2RSxJQUFJLENBQUMsaUJBQWlCLENBQUMsR0FBRyxDQUFDLFVBQVUsRUFBRSxNQUFNLENBQUMsQ0FBQztJQUNqRCxDQUFDO0lBQ0QsTUFBTSxFQUFFLEdBQUcsRUFBRSxHQUFFLENBQUM7Q0FDakIsQ0FBQyxDQUFDO0tBQ0YsS0FBSyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hCLGNBQWMsRUFBRSxDQUFDLFVBQWtCLEVBQUUsRUFBRTtRQUNyQyxPQUFPLENBQUMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUMsRUFBRSxNQUFNLEVBQUU7WUFDdEQsRUFBRSxDQUFxQixDQUFDO0lBQzVCLENBQUM7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVOLE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUM7SUFDM0MsaUJBQWlCLEVBQUUsRUFBRTtDQUN0QixDQUFDLENBQUM7QUFFSCxlQUFlLGdCQUFnQixDQUFDIn0=